import { client } from "api";
import { TimeEntryState } from "models/TimeEntry";

export type SetBatchStateRequest = {
  absenceIds: string[];
  state: Omit<TimeEntryState, "PENDING">;
  message?: string;
};

export type SetBatchStateResponse = null;

export const batchUpdateState = (request: SetBatchStateRequest): Promise<SetBatchStateResponse> =>
  client
    .patch<SetBatchStateResponse>("/absence/batch-update-state", request)
    .then((res) => res.data);
